import { Fv, Message, About, Problem, Merit, News } from "../components/Project";
import { Grid, Space } from "../components/Layout";
import { Media, ScrollTop } from "../components/Object";

const Home = () => {

  return (
    <>
      <Fv />
      <Space size={['0 0 36px', '0 0 32px']}>
        <Message />
      </Space>
      
      <About />
      
      <Space size={['120px 0 120px', '80px 0 80px']}>
        <Problem />
      </Space>
      
      <Merit />
      
      <Space size={['120px 0 15px', '80px 0 12px']}>
        <News />
      </Space>
    </>
  );
};

export default Home;
